/* eslint-disable eqeqeq */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { API, defaultLimitPagination, get } from "../../../../config";
import DocumentTypeList from "./components/DocumentTypeList";
import ProjectSubHeader from "../../components/ProjectSubHeader";
import { debounce } from "lodash";
import { useProject } from "../../../common/ProjectContext";
import AddDocumentModal from "./components/AddDocumentModal";
// import ContractFilterCard from "../../../common/ContractFilterCard";
import SearchBox from "../../../common/SearchBox";
import { formatName, formatSubcontractorName } from "../../../common/Misc";
import { MultiSelect } from "primereact/multiselect";
import { getContractorPopupDetail } from "../../sub-contractors/components/SubContractorHelper";

const DocumentNewList = () => {
  const location = useLocation();
  const params = useParams();
  const projectId = params?.project_id;

  const { ProjectReadOnly } = useProject();

  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [stateContactId, setStateContactId] = useState(
    location?.state?.contact_id
  );

  const [documentList, setDocumentList] = useState();
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [documentListLoading, setDocumentListLoading] = useState(false);
  // const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [globalContactSelect, setGlobalContactSelect] = useState([]);
  const [globalContractSelect, setGlobalContractSelect] = useState([]);

  const [selectedContacts, setSelectedContacts] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedMainContacts, setSelectedMainContacts] = useState([]);
  const [contactOptions, setContactOptions] = useState([]);
  const [contactCurrentPage, setContactCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [contactListLoading, setContactListLoading] = useState(false);
  const [contractorDetail, setContractorDetail] = useState();

  const [selectedContracts, setSelectedContracts] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [selectedMainContracts, setSelectedMainContracts] = useState([]);
  const [contractOptions, setContractOptions] = useState([]);
  const [contractCurrentPage, setContractCurrentPage] = useState(1);
  const [contractHasMoreData, setContractHasMoreData] = useState(true);
  const [contractListLoading, setContractListLoading] = useState(false);

  const filterContactInputRef = useRef();
  const filterContractInputRef = useRef();

  const navigate = useNavigate();

  const defaultOption = [
    { label: "Copy Of Contracts", value: 1, tabKey: "copy-of-contracts" },
    // {
    //   label: "Any Contract Variation/Amendment Documents",
    //   value: 2,
    //   tabKey: "variations-contracts",
    // },
    {
      label: "Payment Claims/ Schedules Given And Received",
      value: 3,
      tabKey: "payment-claims-and-schedules",
    },
    { label: "Supporting Documents", value: 4, tabKey: "supporting-documents" },
    { label: "Other Docs", value: 5, tabKey: "others" },
    { label: "Progress Payment", value: 6, tabKey: "progress-payment" },
  ];
  const selectedTab = query.get("tab") || defaultOption[0]?.tabKey;
  const tabsKey = {};
  defaultOption.map((item) => (tabsKey[item?.tabKey] = item.value));

  const defaultActiveKey = tabsKey[selectedTab];
  const [activeTab, setActiveTab] = useState(
    defaultOption?.find((item) => item.value === parseInt(defaultActiveKey))
      ? defaultOption?.find((item) => item.value === parseInt(defaultActiveKey))
          ?.label
      : defaultOption[0]?.label
  );

  const [showAdd, setShowAdd] = useState(false);

  const toggleAddModal = () => {
    setShowAdd(!showAdd);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  //   const searchParam = query.get("search");

  const fetchDocumentList = useCallback(
    async (
      selectedMainContacts,
      selectedMainContracts,
      passLimit,
      passPage
    ) => {
      if (projectId) {
        try {
          setDocumentListLoading(true);
          const { data } = await get(
            `${API.GET_DOCUMENT_LIST}?builder_project_id=${
              projectId ? projectId : ""
            }&limit=${
              passLimit ? passLimit : limit ? limit : defaultLimitPagination
            }&page=${passPage ? passPage : page ? page : 1}&document_type=${
              defaultOption?.find((item) => item.label === activeTab)?.value
                ? defaultOption?.find((item) => item.label === activeTab)?.value
                : ""
            }&contacts=${
              selectedMainContacts
                ? selectedMainContacts
                : globalContactSelect
                ? globalContactSelect
                : ""
            }&contracts=${
              selectedMainContracts
                ? selectedMainContracts
                : globalContractSelect
                ? globalContractSelect
                : ""
            }&search=${searchParam ? searchParam : ""}`
          );
          setDocumentListLoading(false);
          setLimit(data?.data?.per_page);
          setPage(data?.data?.current_page);
          setTotal(data?.data?.total);
          setFrom(data?.data?.from);
          setTo(data?.data?.to);
          setDocumentList(data?.data?.data);
        } catch (error) {
          setDocumentListLoading(false);
          setDocumentList([]);
          if (error?.response?.data?.errors) {
            Object.keys(error?.response?.data?.errors).forEach((key) => {
              toast.error(error?.response?.data?.errors[key][0]);
            });
          } else {
            toast.error(error?.message);
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      projectId,
      searchParam,
      activeTab,
      globalContactSelect,
      globalContractSelect,
    ]
  );

  useEffect(() => {
    navigate(
      `/projects/${projectId}/documents?tab=${
        defaultOption?.find((item) => item.label === activeTab)?.tabKey
          ? defaultOption?.find((item) => item.label === activeTab)?.tabKey
          : ""
      }&search=${searchParam ? searchParam : ""}&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}`,
      {
        replace: true,
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, searchParam, limit, page, activeTab, navigate]);

  useEffect(() => {
    defaultOption?.find((item) => item.label === activeTab)?.value !== 6 &&
      fetchDocumentList(globalContactSelect, globalContractSelect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDocumentList, globalContactSelect, globalContractSelect]);

  const handleContactChange = (e) => {
    setStateContactId();
    setSelectedContacts(e.value);
    myContractResetFunction();
    setSelectedContracts([]);
  };

  const handleApplyFilter = () => {
    setSelectedMainContacts(selectedContacts);
    setGlobalContactSelect && setGlobalContactSelect(selectedContacts);
    filterContactInputRef.current.hide();
    myContractResetFunction();
  };

  const myContactResetFunction = () => {
    setSelectedContacts([]);
    setSelectedMainContacts([]);
    setGlobalContactSelect && setGlobalContactSelect([]);
    myContractResetFunction();
    filterContactInputRef && filterContactInputRef.current.focus();
  };
  const fetchContactData = async () => {
    setContactListLoading(true);

    const contractorDetailData = await getContractorPopupDetail(
      stateContactId,
      true
    );
    const list = {
      label:
        contractorDetailData?.is_pta === 0
          ? `${formatName(
              contractorDetailData?.first_name,
              contractorDetailData?.last_name
            )} (RTA)`
          : contractorDetailData?.is_pta === 1
          ? `${formatName(
              contractorDetailData?.first_name,
              contractorDetailData?.last_name
            )} (PTA)`
          : contractorDetailData?.is_pta === 2
          ? `${formatName(
              contractorDetailData?.first_name,
              contractorDetailData?.last_name
            )} (Withdrawal/General Business)`
          : contractorDetailData?.is_pta === 3
          ? `${formatName(
              contractorDetailData?.first_name,
              contractorDetailData?.last_name
            )} (Principal)`
          : contractorDetailData?.is_pta === 4
          ? `${formatName(
              contractorDetailData?.first_name,
              contractorDetailData?.last_name
            )} (Trustee)`
          : formatSubcontractorName(contractorDetailData),
      value: contractorDetailData?.id,
    };
    setContractorDetail(list);
    setContactListLoading(false);
  };

  useEffect(() => {
    if (stateContactId) {
      fetchContactData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateContactId]);

  const handleContactList = useCallback(
    async (page) => {
      if (page !== 1 && (contactListLoading || !hasMoreData)) return;
      if (page === 1) {
        setContactOptions([]);
      }
      try {
        setContactListLoading(true);
        let response = await get(
          `${API.GET_CONTRACTORS}?builder_project_id=${
            projectId ? projectId : ""
          }&with_pta=1&limit=25&sort_column=name&sort_order=ASC&page=${page}`
        );
        if (response?.data?.status === 200) {
          const list =
            response &&
            response?.data?.data?.data?.length > 0 &&
            response?.data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.is_pta === 0
                    ? `${formatName(item?.first_name, item?.last_name)} (RTA)`
                    : item?.is_pta === 1
                    ? `${formatName(item?.first_name, item?.last_name)} (PTA)`
                    : item?.is_pta === 2
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Withdrawal/General Business)`
                    : item?.is_pta === 3
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Principal)`
                    : item?.is_pta === 4
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Trustee)`
                    : formatSubcontractorName(item),
                value: item?.id,
              };
              return list;
            });
          // setContactOptions(list);
          // setContactListLoading(false);
          let contactItemList = list ? list : [];
          setContactOptions((prev) => [...prev, ...contactItemList]);
          setContactCurrentPage(response?.data?.data?.current_page);
          // Update `hasMoreData` when the last page is reached
          if (
            response?.data?.data?.current_page >=
              response?.data?.data?.last_page ||
            response?.data?.data?.data.length === 0
          ) {
            setHasMoreData(false);
          } else {
            setHasMoreData(true);
          }
          setContactListLoading(false);
        }
      } catch (error) {
        setContactListLoading(false);
        setContactOptions([]);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [projectId]
  );

  useEffect(() => {
    handleContactList(1);
  }, [handleContactList]);

  const contactLoadMoreData = useCallback(
    (event) => {
      const { last } = event;

      // Trigger API call if scrolled near the end of the loaded data
      if (!contactListLoading && hasMoreData && last >= contactOptions.length) {
        handleContactList(contactCurrentPage + 1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contactListLoading, hasMoreData, contactOptions.length]
  );

  const fetchContactSearchData = async (query) => {
    if (query) {
      try {
        setContactListLoading(true);
        const response = await get(
          `${API.GET_CONTRACTORS}?builder_project_id=${
            projectId ? projectId : ""
          }&search=${
            query ? query : ""
          }&with_pta=1&limit=25&sort_column=name&sort_order=ASC&page=1`
        );
        if (response?.data?.status === 200) {
          const list =
            response &&
            response?.data?.data?.data?.length > 0 &&
            response?.data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.is_pta === 0
                    ? `${formatName(item?.first_name, item?.last_name)} (RTA)`
                    : item?.is_pta === 1
                    ? `${formatName(item?.first_name, item?.last_name)} (PTA)`
                    : item?.is_pta === 2
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Withdrawal)`
                    : item?.is_pta === 3
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Principal)`
                    : item?.is_pta === 4
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Trustee)`
                    : formatSubcontractorName(item),
                value: item?.id,
              };
              return list;
            });
          setContactOptions(list);
          setContactCurrentPage(response?.data?.data?.current_page);
          // Update `hasMoreData` when the last page is reached
          if (
            response?.data?.data?.current_page >=
              response?.data?.data?.last_page ||
            response?.data?.data?.data.length === 0
          ) {
            setHasMoreData(false);
          } else {
            setHasMoreData(true);
          }
          setContactListLoading(false);
        }
      } catch (error) {
        setContactListLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    }
  };

  const debouncedFetchData = useMemo(
    () => debounce(fetchContactSearchData, 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Handle filtering
  const handleContactSearch = (event) => {
    const query = event.filter;
    debouncedFetchData(query); // Call debounced function
  };

  // Clean up the debounced function on unmount
  useMemo(() => () => debouncedFetchData.cancel(), [debouncedFetchData]);

  const handleContactFilter = async (e) => {
    if (e?.filter) {
      if (
        contactOptions?.length > 0 &&
        contactOptions?.find((item) => item?.label?.includes(e?.filter))
      ) {
      } else {
        await handleContactSearch(e);
      }
    } else {
      await handleContactList(1);
    }
  };

  const handleContractChange = (e) => {
    setSelectedContracts(e.value);
  };

  const handleContractApplyFilter = () => {
    setSelectedMainContracts(selectedContracts);
    setGlobalContractSelect && setGlobalContractSelect(selectedContracts);
    filterContractInputRef.current.hide();
  };

  const myContractResetFunction = () => {
    setSelectedContracts([]);
    setSelectedMainContracts([]);
    setGlobalContractSelect && setGlobalContractSelect([]);
    filterContractInputRef && filterContractInputRef.current.focus();
  };

  const handleContractList = useCallback(
    async (page) => {
      if (page !== 1 && (contractListLoading || !contractHasMoreData)) return;
      if (page === 1) {
        setContractOptions([]);
      }
      try {
        if (selectedContacts != null) {
          setContractListLoading(true);
          let response = await get(
            `${API.GET_CONTRACTS}?contact_id=${selectedContacts}&builder_project_id=${projectId}&limit=25&page=${page}`
          );
          if (response?.data?.status === 200) {
            const list =
              response &&
              response?.data?.data?.data?.length > 0 &&
              response?.data?.data?.data?.map((item) => {
                const list = {
                  label: item?.contract_number,
                  value: item?.id,
                  ...item,
                };
                return list;
              });
            // setContractOptions(list ? list : []);
            // setLoading(false);
            let contractItemList = list ? list : [];
            setContractOptions((prev) => [...prev, ...contractItemList]);
            setContractCurrentPage(response?.data?.data?.current_page);
            // Update `hasMoreData` when the last page is reached
            if (
              response?.data?.data?.current_page >=
                response?.data?.data?.last_page ||
              response?.data?.data?.data.length === 0
            ) {
              setContractHasMoreData(false);
            } else {
              setContractHasMoreData(true);
            }
            setContractListLoading(false);
          }
        }
      } catch (error) {
        setContractOptions([]);
        setContractListLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [projectId, selectedContacts]
  );

  useEffect(() => {
    handleContractList(1);
  }, [handleContractList]);

  const contractLoadMoreData = useCallback(
    (event) => {
      const { last } = event;

      // Trigger API call if scrolled near the end of the loaded data
      if (
        !contractListLoading &&
        contractHasMoreData &&
        last >= contractOptions.length
      ) {
        handleContractList(contractCurrentPage + 1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contractListLoading, contractHasMoreData, contractOptions.length]
  );

  const fetchContractSearchData = async (query) => {
    if (query) {
      try {
        setContractListLoading(true);
        const response = await get(
          `${API.GET_CONTACTS}?builder_project_id=${
            projectId ? projectId : ""
          }&search=${
            query ? query : ""
          }&with_pta=1&limit=25&sort_column=name&sort_order=ASC&page=1`
        );
        if (response?.data?.status === 200) {
          const list =
            response &&
            response?.data?.data?.data?.length > 0 &&
            response?.data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.is_pta === 0
                    ? `${formatName(item?.first_name, item?.last_name)} (RTA)`
                    : item?.is_pta === 1
                    ? `${formatName(item?.first_name, item?.last_name)} (PTA)`
                    : item?.is_pta === 2
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Withdrawal)`
                    : item?.is_pta === 3
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Principal)`
                    : item?.is_pta === 4
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Trustee)`
                    : formatSubcontractorName(item),
                value: item?.id,
              };
              return list;
            });
          setContractOptions(list);
          setContractCurrentPage(response?.data?.data?.current_page);
          // Update `hasMoreData` when the last page is reached
          if (
            response?.data?.data?.current_page >=
              response?.data?.data?.last_page ||
            response?.data?.data?.data.length === 0
          ) {
            setContractHasMoreData(false);
          } else {
            setContractHasMoreData(true);
          }
          setContractListLoading(false);
        }
      } catch (error) {
        setContractListLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    }
  };

  const debouncedContractFetchData = useMemo(
    () => debounce(fetchContractSearchData, 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Handle filtering
  const handleContractSearch = (event) => {
    const query = event.filter;
    debouncedContractFetchData(query); // Call debounced function
  };

  // Clean up the debounced function on unmount
  useMemo(
    () => () => debouncedContractFetchData.cancel(),
    [debouncedContractFetchData]
  );

  const handleContractFilter = async (e) => {
    if (e?.filter) {
      if (contractOptions?.find((item) => item?.label?.includes(e?.filter))) {
      } else {
        await handleContractSearch(e);
      }
    } else {
      await handleContractList(1);
    }
  };

  const handleFetchContact = useCallback(async () => {
    if (location?.state?.contact_id) {
      setStateContactId(location?.state?.contact_id);
    }
    if (stateContactId) {
      setSelectedContacts([stateContactId]);
      setSelectedMainContacts([stateContactId]);
      setGlobalContactSelect && setGlobalContactSelect([stateContactId]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.contact_id]);

  useEffect(() => {
    handleFetchContact();
  }, [handleFetchContact]);

  const handleFetchContract = useCallback(async () => {
    if (stateContactId) {
      let tempOptions = contractOptions?.filter(
        (option, index, self) =>
          index === self.findIndex((o) => o.value === option.value)
      );
      let contracts = tempOptions?.map((item) => item?.value);

      setSelectedContracts(contracts);
      setSelectedMainContracts(contracts);
      setGlobalContractSelect && setGlobalContractSelect(contracts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractOptions, stateContactId]);

  useEffect(() => {
    handleFetchContract();
  }, [handleFetchContract]);

  return (
    <>
      <div className="cms-page doc-list-page">
        <div className="page-content-block">
          <div className="full-content-block">
            <ProjectSubHeader title={"Documents"} />
            <div className="content-details">
              {/* {contactListLoading || <Spin />} */}
              <div className="table-top-btn">
                <div className="filter-selections">
                  <MultiSelect
                    value={selectedContacts}
                    onChange={(e) => {
                      handleContactChange(e);
                    }}
                    options={
                      contactOptions?.length > 0
                        ? contactOptions?.filter(
                            (option, index, self) =>
                              index ===
                              self.findIndex((o) => o.value === option.value)
                          )
                        : []
                    }
                    showSelectAll={false}
                    optionLabel="label"
                    filter
                    placeholder="Select Subcontractor(s)"
                    maxSelectedLabels={1}
                    selectedItemTemplate={(e) =>
                      selectedContacts?.length === 1 &&
                      contactOptions?.find((item) => item.value === e)?.label
                        ? contactOptions?.find((item) => item.value === e)
                            ?.label
                        : stateContactId
                        ? contractorDetail
                          ? contractorDetail?.label
                          : ""
                        : ""
                    }
                    selectedItemsLabel={`${selectedContacts?.length} Subcontractor(s) Selected`}
                    onHide={() => {
                      setSelectedMainContacts(selectedContacts);
                      setGlobalContactSelect &&
                        setGlobalContactSelect(selectedContacts);
                      myContractResetFunction();
                    }}
                    style={{
                      fontSize: "13px",
                      maxWidth: "350px",
                      minWidth: "290px",
                      height: "33.563px",
                    }}
                    loading={contactListLoading}
                    onFilter={(e) => handleContactFilter(e)}
                    virtualScrollerOptions={{
                      lazy: true, // Enables lazy loading
                      onLazyLoad: contactLoadMoreData, // Triggered on scroll
                      itemSize: 40, // Height of each item
                    }}
                    ref={filterContactInputRef}
                    panelFooterTemplate={
                      <>
                        <Button
                          className="multiSelect-button"
                          onClick={() => {
                            handleApplyFilter();
                          }}
                        >
                          Apply
                        </Button>
                        <Button
                          className="multiSelect-button"
                          onClick={() => {
                            myContactResetFunction();
                          }}
                        >
                          Reset
                        </Button>
                      </>
                    }
                  />
                  <MultiSelect
                    value={selectedContracts}
                    onChange={(e) => {
                      handleContractChange(e);
                    }}
                    options={
                      contractOptions?.length > 0
                        ? contractOptions?.filter(
                            (option, index, self) =>
                              index ===
                              self.findIndex((o) => o.value === option.value)
                          )
                        : []
                    }
                    showSelectAll={false}
                    optionLabel="label"
                    filter
                    placeholder="Select Contract(s)"
                    disabled={selectedContacts?.length === 0}
                    title={
                      selectedContacts?.length === 0
                        ? "Please Select Subcontractor First"
                        : ""
                    }
                    maxSelectedLabels={1}
                    selectedItemTemplate={(e) =>
                      selectedContracts?.length === 1 &&
                      contractOptions?.find((item) => item.value === e)?.label
                    }
                    selectedItemsLabel={`${selectedContracts?.length} Contract(s) Selected`}
                    onHide={() => {
                      setSelectedMainContracts(selectedContracts);
                      setGlobalContractSelect &&
                        setGlobalContractSelect(selectedContracts);
                    }}
                    style={{
                      fontSize: "13px",
                      maxWidth: "350px",
                    }}
                    loading={contractListLoading}
                    onFilter={(e) => handleContractFilter(e)}
                    virtualScrollerOptions={{
                      lazy: true, // Enables lazy loading
                      onLazyLoad: contractLoadMoreData, // Triggered on scroll
                      itemSize: 40, // Height of each item
                    }}
                    ref={filterContractInputRef}
                    panelFooterTemplate={
                      <>
                        <Button
                          className="multiSelect-button"
                          onClick={() => {
                            handleContractApplyFilter();
                          }}
                        >
                          Apply
                        </Button>
                        <Button
                          className="multiSelect-button"
                          onClick={() => {
                            myContractResetFunction();
                          }}
                        >
                          Reset
                        </Button>
                      </>
                    }
                  />
                </div>
                <SearchBox
                  className={"sub-contract-filter"}
                  placeholder={"Search Document"}
                  searchParamData={searchParamData}
                  handleSearchChange={handleSearchChange}
                  handleClearSearch={handleClearSearch}
                />
                <div className="table-btn">
                  {/* <ContractFilterCard
                    isPopupVisible={isPopupVisible}
                    setIsPopupVisible={setIsPopupVisible}
                    handleFetch={fetchDocumentList}
                    setLoading={setDocumentListLoading}
                    setGlobalContactSelect={setGlobalContactSelect}
                    setGlobalContractSelect={setGlobalContractSelect}
                  /> */}
                  {!ProjectReadOnly && (
                    <Button variant="primary" onClick={toggleAddModal}>
                      Add New
                    </Button>
                  )}
                </div>
              </div>
              <div className="table-top-btn">
                <ul
                  className="nav nav-tabs"
                  onClick={(event) => {
                    setDocumentList();
                    setActiveTab(event?.target?.innerText);
                    setPage(1);
                    setLimit(limit ? limit : defaultLimitPagination);
                  }}
                >
                  {defaultOption?.map((item) => (
                    <li className={activeTab === item?.label ? "active" : ""}>
                      <Link key={item?.value}>{item?.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="custom-table tab-table">
                {defaultOption?.map((item) => (
                  <>
                    {activeTab === item?.label && (
                      <DocumentTypeList
                        type={item}
                        searchParam={searchParam}
                        documentList={documentList}
                        setLimit={setLimit}
                        setPage={setPage}
                        documentListLoading={documentListLoading}
                        total={total}
                        page={page}
                        limit={limit}
                        to={to}
                        from={from}
                        fetchDocumentList={fetchDocumentList}
                        globalContactSelect={globalContactSelect}
                        globalContractSelect={globalContractSelect}
                        contractOptions={contractOptions}
                        handleAdd={() => {
                          fetchDocumentList(
                            globalContactSelect,
                            globalContractSelect,
                            limit,
                            page
                          );
                          myContactResetFunction();
                          handleContractList();
                        }}
                      />
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAdd && (
        <AddDocumentModal
          toggleAddModal={toggleAddModal}
          showAdd={showAdd}
          documentType={
            defaultOption?.find((item) => item.label === activeTab)?.value
          }
          handleAdd={() => {
            fetchDocumentList(
              globalContactSelect,
              globalContractSelect,
              limit,
              page
            );
            myContactResetFunction();
            handleContractList();
          }}
        />
      )}
    </>
  );
};
export default DocumentNewList;
